'use strict'
import axios from "axios";
import store from '../store';

export default class Pin {
    static RequestCustomerPin() {
        if(process.env.NODE_ENV === 'development') return this.developmentRequestCustomerPin();
        return axios.get( `../${store.getters.getConfig['request_customer_pin']}`, {
            headers: {
                'access_key': store.getters.getAccessKey,
                'metadata': store.getters.getMetadataCookie
            }
        });
    }

    static developmentRequestCustomerPin() {
        return axios.get('/api/customer/token');
    }

    static validateCustomerPin() {
        if(process.env.NODE_ENV === 'development') return this.developmentValidateCustomerPin();
        return axios.get(`../${store.getters.getConfig['validate_customer_pin']}`, {
            headers: {
                'access_key': store.getters.getAccessKey,
                'metadata': store.getters.getMetadataCookie,
                'pin' : window.btoa(String(store.getters.getCode).replaceAll(",", "")),
                'pinToken' : window.btoa(store.getters.getPinToken)
            }
        });
    }

    static developmentValidateCustomerPin() {
        return axios.get('/api/changechip/validateCustomerPin', {
            headers: {
                'access_key': store.getters.getAccessKey,
                'metadata': store.getters.getMetadataCookie,
                'pin' : window.btoa(String(store.getters.getCode).replaceAll(",", "")),
                'pinToken' : window.btoa(store.getters.getPinToken)
            }
        });
    }
}
